import { NasGroupConstants } from "../constants/nas_group.constants";

const NasGroupReducer = (state, action) => {
  switch (action.type) {
    case NasGroupConstants.FETCH_NAS_GROUP_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case NasGroupConstants.FETCH_NAS_GROUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        nasGroups: action.payload.data,
        paging: action.payload.paging,
      };
    case NasGroupConstants.FETCH_NAS_GROUP_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };
    case NasGroupConstants.FETCH_NAS_GROUP_MAP_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case NasGroupConstants.FETCH_NAS_GROUP_MAP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        nasGroupMaps: action.payload.data,
        paging: action.payload.paging,
      };
    case NasGroupConstants.FETCH_NAS_GROUP_MAP_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case NasGroupConstants.NAS_GROUP_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case NasGroupConstants.NAS_GROUP_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        nasGroupSearchResults: action.payload,
      };
    case NasGroupConstants.NAS_GROUP_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case NasGroupConstants.ADD_NAS_GROUP_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case NasGroupConstants.ADD_NAS_GROUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case NasGroupConstants.ADD_NAS_GROUP_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
        errorMessage: action.payload.message,
      };

    case NasGroupConstants.ADD_NAS_GROUP_MAP_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case NasGroupConstants.ADD_NAS_GROUP_MAP_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case NasGroupConstants.ADD_NAS_GROUP_MAP_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
        errorMessage: action.payload.message,
      };

    case NasGroupConstants.GET_NAS_GROUP_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case NasGroupConstants.GET_NAS_GROUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        nasGroup: action.payload,
      };
    case NasGroupConstants.GET_NAS_GROUP_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case NasGroupConstants.UPDATE_NAS_GROUP_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case NasGroupConstants.UPDATE_NAS_GROUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        nasGroup: action.payload,
      };
    case NasGroupConstants.UPDATE_NAS_GROUP_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };
    case NasGroupConstants.DOWNLOAD_NAS_GROUP_REQUEST:
      console.log("action33333333", action.payload);
      return {
        ...state,
        isLoadingDownload: true,
        hasError: false,
        downloadFileType: action.payload.fileType,
      };
    case NasGroupConstants.DOWNLOAD_NAS_GROUP_SUCCESS:
      return {
        ...state,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case NasGroupConstants.DOWNLOAD_NAS_GROUP_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case NasGroupConstants.UPLOAD_NAS_GROUP_REQUEST:
      return {
        ...state,
        isUpload: true,
        uploadError: false,
      };
    case NasGroupConstants.UPLOAD_NAS_GROUP_SUCCESS:
      return {
        ...state,
        uploadSuccess: true,
        uploadError: false,
        isUpload: false,
      };
    case NasGroupConstants.UPLOAD_NAS_GROUP_FAILURE:
      return {
        ...state,
        uploadError: true,
        isUpload: false,
      };
    case NasGroupConstants.ADD_NAS_GROUP_TENANT_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case NasGroupConstants.ADD_NAS_GROUP_TENANT_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
      };
    case NasGroupConstants.ADD_NAS_GROUP_TENANT_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
        errorMessage: action.payload.message,
      };

    case NasGroupConstants.FETCH_NAS_GROUP_TENANT_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case NasGroupConstants.FETCH_NAS_GROUP_TENANT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        addOnTenants: action.payload.data,
        paging: action.payload.paging,
      };
    case NasGroupConstants.FETCH_NAS_GROUP_TENANT_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case NasGroupConstants.NAS_GROUP_AUTO_SEARCH_REQUEST:
      return {
        ...state,
        isLoadingAutoSearch: true,
        hasError: false,
      };
    case NasGroupConstants.NAS_GROUP_AUTO_SEARCH_SUCCESS:
      return {
        ...state,
        isLoadingAutoSearch: false,
        nasGroupAutoSearchResults: action.payload,
      };
    case NasGroupConstants.NAS_GROUP_AUTO_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoadingAutoSearch: false,
      };
    case NasGroupConstants.DELETE_NAS_GROUP_MAP_REQUEST:
      return {
        ...state,
        isLoadingDelete: true,
        hasError: false,
      };
    case NasGroupConstants.DELETE_NAS_GROUP_MAP_SUCCESS:
      return {
        ...state,
        isLoadingDelete: false,
      };
    case NasGroupConstants.DELETE_NAS_GROUP_MAP_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoadingDelete: false,
      };

    default:
      return state;
  }
};

export default NasGroupReducer;
